/** ZOY-632: the rule list as the panel shows it — labels in the reader's language. */

import type { IntlShape } from 'react-intl';
import type { PasswordRule } from './passwordRules';
import { PASSWORD_MAX, PASSWORD_MIN } from './passwordRules';

/** Which password the new one must differ from, as this screen knows it. */
export type PreviousKind = 'current' | 'temporary' | 'previous';

export function ruleRows(intl: IntlShape, rules: readonly PasswordRule[], previous: PreviousKind) {
  return rules.map((r) => ({
    id: r.id,
    state: r.state,
    label:
      r.id === 'length'
        ? intl.formatMessage({ id: 'pw.ruleLength' }, { min: PASSWORD_MIN, max: PASSWORD_MAX })
        : intl.formatMessage({ id: `pw.ruleDifferent.${previous}` }),
  }));
}
